export default __webpack_public_path__ + "media/images/elephant-fren-4dab6eb557c6012fef200dc8d2149e9f.png";